import { hasData } from "./hasData"
import { IsJsonValid } from "./isJsonValid"

export const validTipJar = (profiledata) => {
    if (profiledata?.bol_tip_jar?.toString() == "0") return false
    if (parseInt(profiledata?.contributor_level) <= 0 && !hasData(profiledata?.tip_jar_url)) return false
    if (parseInt(profiledata?.contributor_level) >= 1 && (!profiledata || !IsJsonValid(profiledata?.tip_jar_json) || !hasData(JSON.parse(profiledata?.tip_jar_json)?.items[0]?.fieldUrl))) return false
    return true
}